import api from './api.js'

export const getDashboardStats = () => api.get('/admin/v1/dashboard/stats')
